module.exports = __webpack_public_path__ + "static/media/survey_1.a3b9dac8.svg";